var $ = require('../internals/export');
var global = require('../internals/global');

// `globalThis` object
// https://github.com/tc39/proposal-global
$({ global: true }, {
  globalThis: global
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/es.global-this.js
// module id = 317
// module chunks = 48